import React, { useState } from 'react';
import { Cita } from '../../services/citasService';
import { OperadorPinDialog, useOperadorGrant } from '../pos/OperadorPinDialog';
import CancelarReservaPanel, { bloqueoCancelacion } from './CancelarReservaPanel';

export default function CancelarReservaPOS({ cita, sesionPosId, operadorToken, onSuccess }: {
  cita: Cita; sesionPosId: number; operadorToken?: string | null;
  onSuccess: (actualizada: Cita) => void;
}) {
  const [abierto, setAbierto] = useState(false);
  const operador = useOperadorGrant(cita.sesion_pos ?? null);
  const token = cita.sesion_pos === sesionPosId ? operadorToken || operador.token : operador.token;
  const bloqueo = bloqueoCancelacion(cita) || (!cita.sesion_pos ? 'La reserva no tiene una caja asignada.' : '');
  return <section className="rw-cancel" aria-label="Cancelación de reserva">
    <button type="button" className="rw-button rw-danger" disabled={!!bloqueo} title={bloqueo || undefined} onClick={() => setAbierto(true)}>Cancelar reserva</button>
    {bloqueo && <p className="rw-small">{bloqueo}</p>}
    {abierto && <CancelarReservaPanel cita={cita} token={token} onIdentify={operador.openDialog} onClose={() => setAbierto(false)} onSuccess={actualizada => { setAbierto(false); onSuccess(actualizada); }}/>}
    <OperadorPinDialog open={operador.dialogOpen} sesionId={cita.sesion_pos ?? null} onClose={operador.closeDialog} onGrant={operador.install}/>
  </section>;
}
